import { ExpandLess, ExpandMore, Notes } from "@mui/icons-material";
import AccordionList from "../../../../../ui library/components/accordions/AccordionList";
import FollowUpAccordionDetails from "./components/FollowUpAccordion/FollowUpAccordionDetails";
import FollowUpAccordionSummary from "./components/FollowUpAccordion/FollowUpAccordionSummary";
import Accordion from "../../../../../ui library/components/accordions/Accordion";
import useService from "../../../../../../hooks/useService";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import { useFollowUpHistoryStore } from "./hooks/useFollowUpHistory";
import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";

export default function FollowUpHistory() {
  const followUpHistoryRepository = useService(
    "repositories/actionable-items-repository"
  );
  const { id: caseId } = useParams();
  const [followUpHistoryData, setFollowUpHistoryData] = useState([]);
  const [showMoreFollowUpVisible, setShowMoreFollowUpVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const { shouldFetchData, setShouldFetchData, orderingVal, limit, setLimit } = useFollowUpHistoryStore();
  const [currentLimit, setCurrentLimit] = useState(limit + 0);

  const handleShowMoreBtnClick = () => {
    setCurrentLimit(limit + currentLimit);
    setShouldFetchData(true);
  }

  useEffect(() => {
    const fetchData = async () => {
      const data = await followUpHistoryRepository.query({
        on_case: caseId,
        limit: currentLimit,
        action_type__in: "2,3,4",
        status: "done",
        ordering: orderingVal,
      });

      const totalRecords = await followUpHistoryRepository.getTotalCount();

      if(totalRecords > currentLimit) {
        setShowMoreFollowUpVisible(true);
      }
      else{
        setShowMoreFollowUpVisible(false);
      }
      setFollowUpHistoryData(data);
      setLoading(false);
      setShouldFetchData(false);
    };

    fetchData();

  }, [caseId, followUpHistoryRepository, shouldFetchData]);

  return (
    <div className="rounded-md w-full mt-2 p-2 flex flex-col max-h-screen">
        <div className="p-2">
      <div className="border-black border-1 border-b w-full">
        <h2 className="w-full text-center py-1 text-lg flex items-center flex-row">
          <div className="block mr-1 mb-1">
            <Notes />
          </div>
          <span className="block">Follow-Up History</span>
        </h2>
      </div>
      </div>
      {loading ? (
        <div className="w-full h-full flex items-center justify-center flex-1 p-2">
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <div className="flex-1 overflow-auto p-2 flex flex-col">
         {followUpHistoryData.length === 0 ?
         <div className="h-full items-center">
         <Typography className="text-gray-500 text-center text-lg">Nothing to show</Typography>
         </div>
         :
         <>
          <AccordionList
            accordionListData={followUpHistoryData}
            accordionVariant="default"
            summaryContent={FollowUpAccordionSummary}
            expandedContent={<FollowUpAccordionDetails />}
            expandIcon={<ExpandMore className="text-gray-500" />}
            shrinkIcon={<ExpandLess className="text-gray-500" />}
          >
            <Accordion />
          </AccordionList>
          <CustomIconButton
            iconVisible={showMoreFollowUpVisible}
            handleOnClick={handleShowMoreBtnClick}
          />
          </>
         }
        </div>
      )}
    </div>
  );
}
